import { render, staticRenderFns } from "./bottom.vue?vue&type=template&id=85c53da8"
import script from "./bottom.vue?vue&type=script&lang=ts"
export * from "./bottom.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports